
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import {FirebaseDB} from "../../FirebaseDB"

import { withTranslation } from 'react-i18next';
import AdComponent from './AdComponent';
// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";



class DownloadCom extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
//        login : Login
    }

    this.previousWidth = -1;
  }

  render() {

    const { t } = this.props;

    return (

      <Container  fluid className={classNames('content', { 'is-open': this.props.isOpen })}>
        {/* <NavBar toggle={this.props.toggle} /> */}

        {/* <LoginContext.login></LoginContext.login> */}


        <div >


        <img style={{ marginBottom : 60,marginRight : 20}} height="360" width="360"  src='./img/download1.jpg'/>
        


        <h3>{t("download_link")}</h3>

        <a href='https://play.google.com/store/apps/details?id=com.cctv.android.camerax.video&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank" >
          <img height="80" width="180" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
          </a>


          <h3>{t("download_link2")}</h3>

          </div>
            
        
      </Container>
      
      
    );
  }
}




export default withTranslation()(DownloadCom);
